import { Box, Typography, Checkbox } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import useTitanApp from "../../hooks/useTitanApp";
import NMSRateOptions from "./NMSRateOptions";

export default function OrbitSendModal() {
    const { appState } = useTitanApp();
    const { darkMode } = appState || {};
    const checkIconColor = darkMode === true ? "white" : "black";
    const optionsAutomation = [
        {
            title: "Setup Automation",
            description: "You can  automate this process from now on for all new NMS when they arrive",
        },
    ];
    return (
        <div>
            <div className="modal-section">
                <Typography
                    variant="nms-title-orbit"
                    fontWeight="bold"
                >
                    Default Pricing{" "}
                </Typography>
                <Typography className="nms-to-orbit-description">
                    Your services will be picked up by any one of
                    our Orbit Partners based on the rate below:
                </Typography>
                <NMSRateOptions
                    consentedRate={5}
                    unConsentedRate={8}
                />
            </div>
            <div className="modal-section">
                <Typography
                    variant="nms-title-orbit"
                    fontWeight="bold"
                >
                    {" "}
                    Automation{" "}
                </Typography>
                {optionsAutomation?.map(
                    ({ title, description }) => (
                        <Box>
                            <div className="nms-to-orbit-option">
                                <div className="nms-to-orbit-option-header">
                                    <Typography
                                        id="modal-title"
                                        variant="h6"
                                        sx={{
                                            fontSize: "14px",
                                            marginBottom: "15px",
                                        }}
                                    >
                                        {" "}
                                        {title}{" "}
                                    </Typography>
                                    <Checkbox
                                        checkedIcon={
                                            <CheckCircleIcon
                                                sx={{ color: checkIconColor }}
                                            />
                                        }
                                        checked={true}
                                    />
                                </div>
                                <div className="nms-text-orbit-wrapper">
                                    <Typography className="nms-to-orbit-description">
                                        {description}{" "}
                                    </Typography>
                                </div>
                            </div>
                        </Box>
                    )
                )}
            </div>
        </div>
    )
}
